<template lang="pug">
section(class="data-logger", v-bind:class="{'logger-absolute': toggle, 'logger-inline': !toggle}")
  header
    button(v-text="loggerTitle", v-on:click="toggleLogger()")
    span(v-if="toggle")
      button(v-text="'Paste Object to console'", v-on:click="pasteToConsole()")
      button(v-text="'Paste Json to console'", v-on:click="pasteToConsoleInJson()")
  article(v-if="toggle")
    small(v-text="dataLength")
    pre(v-text="data")
</template>
<script>
export default {
  name: 'data-logger',
  /**
   * Properties nedded
   * @type Array
   */
  props: [
    /**
     * Object to log
     * -- Required !
     * @type Object
     */
    'data',
    /**
     * Logger name
     * -- Optional
     * @type String
     */
    'name'
  ],
  data () {
    return {
      toggle: false
    }
  },
  computed: {
    /**
     * Return humanized data length of data object
     * @return String
     */
    dataLength: function () {
      return [
        'Data length',
        JSON.stringify(this.data).length,
        'Char'
      ].join(' ')
    },
    /**
     * Return humanized logger title
     * @return String
     */
    loggerTitle: function () {
      var suffixTitle = 'logger'
      if (this.name === '') {
        return ['Data', suffixTitle].join(' ')
      } else {
        return this.name
      }
    }
  },
  methods: {
    /**
     * Toggle the logger
     */
    toggleLogger: function () {
      this.toggle = !this.toggle
    },
    /**
     * Paste the object in the console
     */
    pasteToConsole: function () {
      console.log(this.data)
    },
    /**
     * Paste the object in JSON format in the console
     */
    pasteToConsoleInJson: function () {
      console.log(JSON.stringify(this.data))
    }
  }
}
</script>
<style lang="scss" scoped>
  section {
    margin: 10px 0px;
  }
  header {
    button {
      cursor: pointer;
      min-width: 50px;
      border: 0px solid;
      -webkit-border-radius: 4;
      -moz-border-radius: 4;
      border-radius: 4px;
      color: #ffffff;
      background: #4fc08d;
      padding: 5px 10px 5px 10px;
      text-decoration: none;
      &:hover {
        background: #7ebda1;
        text-decoration: none;
      }
    }
    span {
      margin-left: 5px;
      button {
        cursor: pointer;
        margin: 0px 5px;
        padding: 1px 5px;;
        min-width: auto;
        font-size: 0.7em;
        height: 20px;
        vertical-align: middle;
      }
    }
  }
  article {
    background: #F3F3F3;
    border: 1px solid grey;
    padding: 5px;
  }
  pre {
    background: #263238;
    color: #aabbc3;
    margin: 5px 0px;
    padding: 5px 2px;
    font-size: 12px;
    line-height: 18px;
    max-height: 250px;
    min-height: 50px;
    overflow: scroll;
  }
  .logger-absolute {
    display: block;
  }
  .logger-inline {
    display: inline-block;;
  }
</style>



// WEBPACK FOOTER //
// DataLogger.vue?416bbb94